module.exports = __webpack_public_path__ + "static/folder-89e7b7b0576ac3d01aa2c00b320676ab.png";